<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" ref="form" label-position="left" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" prop="key" placeholder="请输入">
              <el-input v-model="form.key"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="讲解时间 :" prop="date">
              <el-date-picker v-model="form.date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <!-- <div class="button">
        <el-row>

          <el-button round @click="exportList">
            <svg-icon icon-class="add" />&nbsp;导出
          </el-button>
        </el-row>
      </div> -->
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData" @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column label="序号"  width="80">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="exhibitionName" label="展览名称" min-width="8%">
          </el-table-column>
          <el-table-column prop="floor" label="楼层" min-width="13%"></el-table-column>
          <el-table-column prop="exhibition" label="展厅" min-width="7%"></el-table-column>
          <el-table-column prop="appointment_date" label="讲解时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="appointment_time" label="讲解时段" min-width="10%" show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column prop="checkTimeBegin" label="讲解场次" min-width="10%" show-overflow-tooltip></el-table-column> -->

          <!-- 操作 -->
          <!-- <el-table-column fixed="right" label="操作" min-width="18%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="sign(scope.row)">查看</a>
              <a class="m-btn mr-10" @click="sign(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="sign(scope.row)">删除</a>
            </template>
          </el-table-column> -->
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {
    // dialogActivityInfo,
    // dialogQrcode
  },
  data() {
    return {
      that: this,
      form: {
        time: "",
        key: ''
      },
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
    }
  },
  filters: {
    filterVolunteerRecruit(status, context) {
      let arr = context.statusList.filter(item => {
        return item.dictCode == status
      })

      if (arr && arr.length > 0) {
        return arr[0].dictName
      }

      return null
    },
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      this.$api.volunteer.appointmentExplain({
        id: this.$route.query.id,
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result) {
            this.tableData = res.result.records || []
            this.total = res.result.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },


    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()

    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    sign(obj) {
      this.$common.confirm(
        {
          title: '签到',
          content: '确认签到？'
        }, () => {
          this.$api.volunteer.volunteerCheck({ id: obj.id, sign: obj.sign }).then(res => {
            if (res.success) {
              this.$message.success('签到成功')
              this.initList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 导出
    exportList() {
      window.location.href = `/singleMuseum/v2/bsVolunteerV2ExhibitionDetailUser/export?page=${this.listQuery.currentPage}&size=${this.listQuery.size}&date=${this.form.date}&key=${this.form.key}`
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.schemeId)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    }
  },
  created() {
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-manage {
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .nav-item {
      margin-bottom: 10px;
      padding: 5px 10px;
      color: $color6;
      font-size: 14px;
      border: solid 1px $border;
      border-radius: 4px;
      margin-right: 20px;
      cursor: pointer;
      &.active {
        background-color: $primary;
        color: #fff;
        border-color: $primary;
      }
    }
  }
}
</style>